import isEmpty from "lodash.isempty";

const theme = {
  footerBackgroundColor: "transparent",
  jobCardBackgroundColor: "#FFFFFF",
  negativeTextColor: "#FFFFFF",
  primaryBackgroundColor: "#FFFFFF",
  primaryColor: "#CE132D",
  secondaryBackgroundColor: "#F1F0E9",
  secondaryColor: "#000000",
  siteMapBackgroundColor: "#FFFFFF",
  siteMapHeaderTextColor: "#000000",
  siteMapTextColor: "#CE132D",
  textColor: "#000000",
};

// eslint-disable-next-line consistent-return
const themeCustomizer = (themeValue, appThemeValue) => {
  // If the custom theme value is explicitly empty or missing, keep the default
  if (appThemeValue === undefined || appThemeValue === null || appThemeValue === "") {
    return themeValue;
  }
  // Otherwise, always trust the incoming appThemeValue
  return appThemeValue;
};

export { theme, themeCustomizer };
